import axiosBaseApi from '../common/lib/axiosBaseApi';
import { HandHistory, HandHistoryDto } from './hand-history.types';

export const getTableHandHistory = async (tableId: string) => {
  return (await axiosBaseApi.get<HandHistory[]>(`/v1/table/${tableId}/hand-history`)).data;
};

export const getFullHandHistory = async (tableId: string, handId: string) => {
  return (await axiosBaseApi.get<HandHistoryDto>(`/v1/table/${tableId}/hand/${handId}`)).data;
};
